import styles from "./styles.module.css";
import { useContext } from "react";
import { BookingCalendarContext } from "../../../context/BookingCalendarContext";
import { DateTime } from "luxon";
import { BookingPreview } from "./BookingPreview";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/Button";

export const CalendarContent = () => {
  const { currentDate, bookings, isLoading, canFetchMore, fetchNextPage } =
    useContext(BookingCalendarContext);
  const { t } = useTranslation();

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        {DateTime.fromISO(currentDate).toLocaleString(DateTime.DATE_HUGE)}
      </div>
      <div className={styles.content}>
        {isLoading && (
          <div className={styles.loading}>
            {t("calendar.loading_placeholder")}
          </div>
        )}
        {bookings.map((booking) => (
          <BookingPreview key={booking.booking_id} booking={booking} />
        ))}
        {bookings.length === 0 && (
          <div className={styles.emptyBox}>{t("calendar.no_bookings")}</div>
        )}
        {canFetchMore && (
          <div className={styles.fetchMoreContainer}>
            <Button
              style={{ backgroundColor: "transparent", color: "black" }}
              onClick={fetchNextPage}
            >
              Fetch more
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};
